import type { ApprovalAction } from '../types/ApprovalAction';
import type { ApprovalType } from '../types/ApprovalType';
import type { ApprovalTypeAction } from '../types/ApprovalTypeAction';

export const getTypeAction = (
  approvalType: ApprovalType,
  approvalAction: ApprovalAction
) => `${approvalType}-${approvalAction}` as ApprovalTypeAction;
